import { useTranslations } from "@zapier/i18n";
import { Alert } from "@zapier/design-system";

interface Props {
  parentFolderName: string;
}

export function NextGenZapSharingAlert({ parentFolderName }: Props) {
  const t = useTranslations("next-gen-zap-sharing-alert");

  return (
    <Alert variant="default" status="info">
      {t.rich("alerts.viewer-role-limit", {
        parentFolderName,
        bold1: (chunks) => <b>{chunks}</b>,
      })}
    </Alert>
  );
}
